import ModelUtil from '@leverege/model-util';
function create(attrName, extend) {
  const type = `${attrName}.Equals`;
  return {
    type,
    TYPE: type,
    attrName,
    name: 'equals',
    create() {
      return {
        type,
        value1: null
      };
    },
    ...ModelUtil.createAllValue('value1'),
    takeValuesFrom(model, oldValue) {
      if (oldValue?.value1 != null) {
        return {
          ...model,
          value1: oldValue?.value1
        };
      }
      return model;
    },
    ...extend
  };
}
export default {
  create
};